module.exports = __webpack_public_path__ + "media/images/twitter-11d300ecf6efe74e0e113dde486e28d2.svg";